module.exports = __webpack_public_path__ + "img/pem_33_halo.7049be7e.png";